import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./About.css";
import Crew1 from "./iSW Banner 1.png";
import Crew2 from "./iSW Banner 2.png";
import Crew3 from "./iSW Banner 3.png";
import Crew4 from "./iSW Banner 4.png";
import AboutFounder from "./AboutFounder";
import TeamAndPartners from "./TeamAndPartners";
import SupportersSponsors from "./SupportersSponsors";
import BecomePartner from "./BecomePartner";
import ProblemSolutionSlides from "./ProblemSolutionSlides";

const crewImages = [Crew1, Crew2, Crew3, Crew4];

function About() {
  const navigate = useNavigate();
  
  // Pick the image once per mount, not on every render
  const [currentIndex] = useState(() => Math.floor(Math.random() * crewImages.length));

  const navigateTo = (path) => navigate(path);

  return (
    <div className="ABO-about-container">
      <h1 className="ABO-about-header-title">The iSpeakWell Project</h1>
      <h5 className="ABO-tagline">Become a member of the iSpeakWell crew.</h5>
      <img
        src={crewImages[currentIndex]}
        alt="Overlay"
        style={{
          position: "relative",
          width: "55%",
          opacity: "0.80",
        }}
      />
      <h3>Practice Speaking with Real Humans & AI.</h3>
      <ProblemSolutionSlides />
      <AboutFounder />
      <TeamAndPartners />
      <SupportersSponsors />
      <BecomePartner />

      <div className="ABO-links-section">
        <button className="ABO-link-button" onClick={() => navigateTo("/about")}>About</button>
        <button className="ABO-link-button" onClick={() => navigateTo("/careers")}>Careers</button>
        <button className="ABO-link-button" onClick={() => navigateTo("/tokens")}>Tokens</button>
        <button className="ABO-link-button" onClick={() => navigateTo("/contactus")}>Contact Us</button>
        <button className="ABO-link-button" onClick={() => navigateTo("/login")}>Login</button>
      </div>
    </div>
  );
}

export default About;
